export default __webpack_public_path__ + "static/media/gb_sample_7.11725154.jpg";